import React, { JSX } from 'react';

import { formatShortMonthWithoutTimeDatetime } from '../../helpers/DateFormatHelper';
import { ScanCrawlStateHelper } from '../../helpers/ScanCrawlStateHelper';
import { isStringMatch } from '../../helpers/StringHelper';
import { IProperty } from '../../interfaces/Property';
import { IScan } from '../../interfaces/Scan';
import { IUrlSet } from '../../interfaces/UrlSet';
import { IFilterOptions } from '../data-filter/DataFilterHelper';
import { StatusIcon } from '../status-icon/StatusIcon';

export const renderDateStatusCol = (
	cell: IUrlSet | IScan,
	isScan: boolean
): JSX.Element | string => {
	if (!cell || !cell.state) {
		return 'N/A';
	}
	const isCanceled = ScanCrawlStateHelper.isCanceled(cell.state);
	if (isCanceled) {
		return 'N/A';
	}
	return (
		<div className="date-status-cell">
			<StatusIcon state={cell.state} isScan={isScan} />
			<div className="time">{formatShortMonthWithoutTimeDatetime(cell.createdTime)}</div>
		</div>
	);
};

export const getFilteredTableData = (
	allProperties: IProperty[],
	{ searchValue, collections }: IFilterOptions = {}
): IProperty[] => {
	const collectionsSet = collections?.length ? new Set(collections.map((c) => c.value)) : null;

	return allProperties.filter((property) => {
		let isSearchMatch = true;
		let isCollectionsMatch = true;

		if (searchValue) {
			isSearchMatch = isStringMatch(searchValue, property.name);
		}

		if (collectionsSet) {
			isCollectionsMatch = property.collections.some((propertyCollection) =>
				collectionsSet.has(propertyCollection.id)
			);
		}

		return isSearchMatch && isCollectionsMatch;
	});
};
